import { HexColor } from '@repo/types/domain';
import { DEFAULT_PROFILE_COLOR } from '../../utils/common/constants';

import { ProfileAvatar } from './index.styles';

export interface ProfileIconProps {
  firstName?: string;
  lastName?: string;
  imageUrl?: string;
  color?: HexColor;
  size?: number;
}

const ProfileIcon = ({
  firstName,
  lastName,
  imageUrl,
  color = DEFAULT_PROFILE_COLOR,
  size,
}: ProfileIconProps) => (
  <ProfileAvatar src={imageUrl} color={imageUrl ? '#fff' : color} size={size}>
    {firstName?.charAt(0)}
    {lastName?.charAt(0)}
  </ProfileAvatar>
);

export default ProfileIcon;
